import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LtiParams } from '@mhe/reader/models';
import { ApiClientSelectorService } from '../core/api-client-selector.service';
import { filter, take, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LtiService {
  constructor(
    private readonly apiClientSelector: ApiClientSelectorService,
  ) { }

  get ltiParameters$(): Observable<LtiParams> {
    // some integrators set LTI params in the URL
    const directLaunchParams = this.loadDirectLaunchParams();
    if (directLaunchParams !== undefined) {
      return of(directLaunchParams);
    }

    // must wait until the playerApiMigrationFactory has run (async APP_INITIALIZER)
    return this.apiClientSelector.apiFlagChecked.pipe(
      filter(flag => flag !== null),
      take(1),
      switchMap(() => {
        // use the dynamic API client based on the session storage flag
        return this.apiClientSelector.getApiClient().fetchLTIParams();
      }),
    );
  }

  private loadDirectLaunchParams(): LtiParams | undefined {
    if (window.location.hash.lastIndexOf('direct-launch') < 0) {
      return undefined;
    }

    const queryString = window.location.hash.replace('#', '?');
    const urlParams = new URLSearchParams(queryString);
    const ltiParams: LtiParams = {};

    urlParams.forEach(function(value, key) {
      ltiParams[key] = value;
    });

    return ltiParams;
  }
}
